function busquedaHome() {
    if ( $( '#buscaInput' ).val() != '' || $( '#busquedaPaisId' ).val() != '' || $( '#busquedaEstadoId' ).val() != '' || $( '#busquedaCiudadId' ).val() != '' ) {
        seteaSesion( 'busquedaGeneral', $( '#buscaInput' ).val() );
        seteaSesion( 'busquedaPaisId', $( '#busquedaPaisId' ).val() );
        seteaSesion( 'busquedaEstadoId', $( '#busquedaEstadoId' ).val() );
        seteaSesion( 'busquedaCiudadId', $( '#busquedaCiudadId' ).val() );
        manda( 'buscar' );
    }
}
function coordenadasBusqueda( position ) {
    seteaSesion( 'latitud', position.coords.latitude );
    seteaSesion( 'longitud', position.coords.longitude );
    realizaBusqueda();
}
function skeletonLista() {
    let html = '';
    for ( let i = 0; i < 10; i++ ) {
        html += '<li style="margin-bottom: 10px;"><div class="skeleton cajas"></div></li>';
    }
    $( '#resultados' ).append( html );
}
function mapaNecesitaInicio() {
    var contenedor = document.getElementById( 'mapa' );
    return typeof map === 'undefined' || !map || !contenedor || contenedor.childNodes.length === 0;
}
function coordenadasLugar( lugar ) {
    return {
        lat: parseFloat( lugar.latitude ),
        lng: parseFloat( lugar.longitude )
    };
}
function masBusqueda() {
    pagina++;
    if ( $( '.masLink' ).length ) { $( '.masLink' ).remove(); }
    iniciaBusqueda();
}
function realizaBusqueda() {
    pagina = 1;
    acumulados = 0;
    if ( $( '.masLink' ).length ) { $( '.masLink' ).remove(); }
    if ( typeof limpiarMarcas === 'function' ) { limpiarMarcas(); }
    $( '#resultCount' ).html( 0 );
    $( '#resultados' ).html( '' );
    iniciaBusqueda();
}
function iniciaBusqueda() {
    skeletonLista();
    var filtros = { 'general': $( '#buscaInput' ).val(), 'page': pagina };
    if ( $( '#paisId' ).val() != '' && $( '#paisId' ).val() != 0 ) { filtros[ 'paisId' ] = $( '#paisId' ).val(); }
    if ( $( '#estadoId' ).val() != '' && $( '#estadoId' ).val() != 0 ) { filtros[ 'estadoId' ] = $( '#estadoId' ).val(); }
    if ( $( '#ciudadId' ).val() != '' && $( '#ciudadId' ).val() != 0 ) { filtros[ 'ciudadId' ] = $( '#ciudadId' ).val(); }
    if ( $( '#categoriaId' ).val() != '' && $( '#categoriaId' ).val() != 0 ) { filtros[ 'categoriaId' ] = $( '#categoriaId' ).val(); }
    if ( checaSesion( 'latitud' ) && checaSesion( 'longitud' ) ) {
        filtros[ 'latitud' ] = obtenSesion( 'latitud' );
        filtros[ 'longitud' ] = obtenSesion( 'longitud' );
    }
    $( '.busquedaCheck' ).each( function() {
        if ( $( this ).is( ':checked' ) ) {
            filtros[ $( this ).attr( 'id' ) ] = 'S';
        }
    } );
    ajaxRequest( false, 'POST', filtros, 'api/busqueda', resultadosBusqueda );
}
function resultadosBusqueda( respuesta ) {
    let html = '';
    const datos = JSON.parse( respuesta );
    const caracteristicasLbl = idioma == 'ES' ? 'Características' : 'Features';
    $( '#busquedaForm .button[type="submit"]' ).removeClass( 'skeleton' );
    if ( datos.status == 'Success' ) {
        acumulados += datos.datos.length;
        let i = 0;
        $.each( datos.datos, function( index, lugar ) {
            let name = idioma == 'ES' ? lugar.name : ( lugar.name_en != null && lugar.name_en != '' ? lugar.name_en : lugar.name );
            var placeId = parseInt( lugar.placeId, 10 );
            var titleId = 'lugar-title-' + placeId;
            var featuresLabelId = 'lugar-features-lbl-' + placeId;
            html += '<li class="item">';
            html += '<article class="item-inner" aria-labelledby="' + titleId + '">';
            if ( lugar.imagen != null && lugar.imagen != '' ) {
                html += '<div class="item-thumb" aria-hidden="true" onclick="manda( \'' + lugar.url + '\' )">';
                html += lugar.imagen;
                if ( lugar.has_distintivo_a == 'SI' || lugar.has_distintivo_a == 'S' ) {
                    html += '<div class="distintivoA"><img src="thumb?src=images/disitintivo_todoa.png&size=100x100&zoom=1" alt="Lugar con Distintivo A"></div>';
                }
                html += '</div>';
            }
            html += '<div class="item-body">';
            html += '<h2 id="' + titleId + '"><a href="' + lugar.url + '">' + name + '</a></h2>';
            html += '<p><i class="fas fa-map-marker-alt" aria-hidden="true"></i> ' + lugar.address + '</p>';
            html += '<p>' + lugar.city + ', ' + lugar.state + ', ' + lugar.postal_code + '</p>';
            html += '<p class="features-label" id="' + featuresLabelId + '">' + caracteristicasLbl + '</p>';
            html += '<div class="features" role="group" aria-labelledby="' + featuresLabelId + '">';
            $.each( lugar.features, function( fIndex, feature ) {
                var tipTitulo = feature.nombre + ' – ' + feature.description;
                html += '<button type="button" class="feature" data-tooltip="' + tipTitulo + '">';
                html += '<img src="thumb?src=images/iconos/' + feature.icono + '&size=20x20&zoom=1" alt="" width="20" height="20" loading="lazy">';
                html += feature.shortname;
                html += '</button>';
            } );
            html += '</div>';
            html += '</div>';
            html += '</article></li>';
            var coords = coordenadasLugar( lugar );
            if ( isNaN( coords.lat ) || isNaN( coords.lng ) ) { return; }
            var color = lugar.categoria && lugar.categoria.color ? lugar.categoria.color : '#d4148e';
            if ( mapaNecesitaInicio() ) {
                map = undefined;
                iniciaMapa( coords.lat, coords.lng, lugar.url, color );
                redimensionaMapaBusqueda();
            } else if ( i === 0 && acumulados >= 20 ) {
                ajustaCentro( coords.lat, coords.lng, lugar.url, color );
            } else {
                var latLong = new google.maps.LatLng( coords.lat, coords.lng );
                agregaMarca( latLong, 1, lugar.url, color );
            }
            i++;
        } );
        const masResultadosTxt = idioma == 'ES' ? 'Cargar mas resultados' : 'Load more results';
        if ( datos.datos.length >= 20 ) {
            html += '<li class="masLink"><a href="javascript:void(0)" class="moreSearch" onclick="masBusqueda()"><i class="fas fa-plus" aria-hidden="true"></i> ' + masResultadosTxt + '</a>';
        }
    } else if ( acumulados == 0 ) {
        let agregarLugar = idioma == 'ES' ? 'Agregar nuevo lugar' : 'Add new place';
        html = '<li class="tCenter"><img src="images/sin-lugares.png" alt="Sin lugares encontrados" class="sinLugares"></li>';
        html += '<li class="tCenter"><a href="agregar-lugar" class="button mCenter">' + agregarLugar + '</a></li>';
    }
    if ( $( '.skeleton.cajas' ).length ) { $( '.skeleton.cajas' ).remove(); }
    if ( $( '.masLink' ).length ) { $( '.masLink' ).remove(); }
    $( '#resultCount' ).html( acumulados );
    $( '#resultados' ).append( html );
    moveAnimate( 'resultCount' );
    if ( typeof map !== 'undefined' ) {
        redimensionaMapaBusqueda();
    }
}
function redimensionaMapaBusqueda() {
    if ( !$( '#mapa' ).length || !$( '.resultadosSplit' ).length ) { return; }
    var $filtros = $( 'aside.filtros' );
    var $resultados = $( '.resultados' );
    var $split = $( '.resultadosSplit' );
    if ( window.innerWidth <= 1080 ) {
        $resultados.css( { height: '', maxHeight: '' } );
        $split.css( { height: '', maxHeight: '', minHeight: '' } );
    } else {
        var alturaFiltros = $filtros.outerHeight();
        var alturaHead = $( '.headResults' ).outerHeight() || 0;
        var paddingVertical = parseFloat( $resultados.css( 'padding-top' ) ) + parseFloat( $resultados.css( 'padding-bottom' ) );
        var marginSplit = parseFloat( $split.css( 'margin-top' ) ) || 0;
        var alturaSplit = alturaFiltros - paddingVertical - alturaHead - marginSplit;
        alturaSplit = Math.max( alturaSplit, 240 );
        $resultados.css( { height: alturaFiltros + 'px', maxHeight: alturaFiltros + 'px' } );
        $split.css( { height: alturaSplit + 'px', maxHeight: alturaSplit + 'px', minHeight: alturaSplit + 'px' } );
    }
    if ( typeof map !== 'undefined' && map ) {
        google.maps.event.trigger( map, 'resize' );
    }
}
function optionEstados( respuesta ) {
    var html = '';
    if ( $( '#buscaHome' ).length > 0 ) {
        $( '#busquedaEstadoId' ).next('.select2-container').removeClass( 'skeleton' );
    } else {
        $( '#estadoId' ).next('.select2-container').removeClass( 'skeleton' );
    }
    var datos = JSON.parse( respuesta );
    if ( datos.status == 'Success' ) {
        html = idioma  == 'ES' ? '<option value="">Elige una opción</option>' : '<option value="">Choose an option</option>';
        datos.datos = Object.values( datos.datos );
        datos.datos.sort( ( a, b ) =>
            a.nombre.localeCompare( b.nombre, idioma == 'ES' ? 'es' : 'en', {
                sensitivity: 'base'
            } )
        );
        $.each( datos.datos, function( index, info ) {
            html += '<option value="' + info.estadoId + '">' + info.nombre + '</option>';
        } );
        if ( $( '#buscaHome' ).length > 0 ) {
            $( '#busquedaEstadoId' ).html( html );
        } else {
            $( '#estadoId' ).html( html );
            if ( estadoActual != 0 && estadoActual != '' && estadoActual != null ) { $( '#estadoId' ).val( estadoActual ).trigger( 'change' ); estadoActual = 0; }
            if ( checaSesion( 'busquedaEstadoId' ) ) { $( '#estadoId' ).val( obtenSesion( 'busquedaEstadoId' ) ).trigger( 'change' ); }
            if ( !checaSesion( 'busquedaCiudadId' ) && checaSesion( 'busquedaEstadoId' ) ) {
                realizaBusqueda();
                borraSesion( 'busquedaEstadoId' );
            }
            if ( $( '#placeForm' ).length > 0 ) {
                cargaSugerencias();
            }
        }
    } else {
        html = idioma  == 'ES' ? '<option value="">Elige una opción</option>' : '<option value="">Choose an option</option>';
        if ( $( '#buscaHome' ).length > 0 ) {
            $( '#busquedaEstadoId' ).html( html );
        } else {
            $( '#estadoId' ).html( html );
        }
    }
}
function optionCiudades( respuesta ) {
    var html = '';
    if ( $( '#buscaHome' ).length > 0 ) {
        $( '#busquedaCiudadId' ).next('.select2-container').removeClass( 'skeleton' );
    } else {
        $( '#ciudadId' ).next('.select2-container').removeClass( 'skeleton' );
    }
    var datos = JSON.parse( respuesta );
    if ( datos.status == 'Success' ) {
        html = idioma  == 'ES' ? '<option value="">Elige una opción</option>' : '<option value="">Choose an option</option>';
        datos.datos = Object.values( datos.datos );
        datos.datos.sort( ( a, b ) =>
            a.nombre.localeCompare( b.nombre, idioma == 'ES' ? 'es' : 'en', {
                sensitivity: 'base'
            } )
        );
        $.each( datos.datos, function( index, info ) {
            html += '<option value="' + info.ciudadId + '">' + info.nombre + '</option>';
        } );
        if ( $( '#buscaHome' ).length > 0 ) {
            $( '#busquedaCiudadId' ).html( html );
        } else {
            $( '#ciudadId' ).html( html );
            if ( ciudadActual != 0 && ciudadActual != '' && ciudadActual != null ) { $( '#ciudadId' ).val( ciudadActual ).trigger( 'change' ); ciudadActual = 0; }
            if ( checaSesion( 'busquedaCiudadId' ) ) { $( '#ciudadId' ).val( obtenSesion( 'busquedaCiudadId' ) ).trigger( 'change' ); }
            if ( checaSesion( 'busquedaCiudadId' ) ) {
                realizaBusqueda();
                borraSesion( 'busquedaCiudadId' );
            }
            if ( $( '#placeForm' ).length > 0 ) {
                cargaSugerencias();
            }
        }
    } else {
        html = idioma  == 'ES' ? '<option value="">Elige una opción</option>' : '<option value="">Choose an option</option>';
        if ( $( '#buscaHome' ).length > 0 ) {
            $( '#busquedaCiudadId' ).html( html );
        } else {
            $( '#ciudadId' ).html( html );
        }
    }
}